import { ReactNode } from "react";
import { cn } from "../lib/utils";
import { ClickableIcon } from "../primitives";

type ModalItemWithHeaderProps = {
	header: ReactNode;
	children?: ReactNode;
	className?: string;
	headerClassName?: string;
	bodyClassName?: string;
	onClose?: () => void;
	headerActions?: ReactNode;
	closeTrackingId?: string;
	closeDisabled?: boolean;
};

export const ModalItemWithHeader = ({
	header,
	children,
	className,
	headerClassName,
	bodyClassName,
	onClose,
	headerActions,
	closeTrackingId,
	closeDisabled,
}: ModalItemWithHeaderProps) => (
	<div
		className={cn(
			"flex flex-col bg-surface-base rounded-md border-bc-default shadow-lg",
			className,
		)}
	>
		<div
			className={cn(
				"flex w-full px-[20px] pt-[14px] pb-[12px] bg-surface-neutral border-b border-b-bc-default rounded-t-md text-[14px] text-primary font-medium shrink-0",
				headerClassName,
			)}
		>
			<div data-testid="modal-item-with-header-value" className="flex-1">
				{header}
			</div>
			<div className="flex items-center gap-2">
				{headerActions}
				<ClickableIcon
					type="x-mark"
					size="small"
					color="secondary"
					testId="modal-close-icon"
					trackingId={closeTrackingId}
					className="mt-[1px]"
					disabled={closeDisabled}
					onClick={(e) => {
						e.stopPropagation();
						onClose?.();
					}}
				/>
			</div>
		</div>
		<div className={cn("w-full flex-1", bodyClassName)}>{children}</div>
	</div>
);
